import { render, staticRenderFns } from "./FieldImage.vue?vue&type=template&id=4edaf9fe&"
import script from "./FieldImage.vue?vue&type=script&lang=ts&"
export * from "./FieldImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports